import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { InventoryComponent } from "./components/InventoryComponent";
import { BlackjackComponent } from "./components/BlackjackComponent";
import { RouletteComponent } from "./components/RouletteComponent";
import { TimeComponent } from "./components/TimeComponent";
import { SpeedrunComponent } from "./components/SpeedrunComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("game-inventory", InventoryComponent);
window.customElements.define("game-blackjack", BlackjackComponent);
window.customElements.define("game-roulette", RouletteComponent);
window.customElements.define("game-time", TimeComponent);
window.customElements.define("game-speedrun", SpeedrunComponent);
